import { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { canAccessMinhasIniciativasElbb } from 'services/minhas-iniciativas-elbb-eligibility.service';

interface MinhasIniciativasElbbEligibleRouteProps {
  children: ReactNode;
}

export function MinhasIniciativasElbbEligibleRoute({
  children,
}: MinhasIniciativasElbbEligibleRouteProps) {
  const { user, loadingUserData } = useAuth();
  const [isChecking, setIsChecking] = useState(true);
  const [isEligible, setIsEligible] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function checkEligibility() {
      if (!user?._id) {
        if (isMounted) {
          setIsEligible(false);
          setIsChecking(false);
        }
        return;
      }

      try {
        const canAccess = await canAccessMinhasIniciativasElbb(user._id);
        if (isMounted) {
          setIsEligible(canAccess);
        }
      } catch {
        if (isMounted) {
          setIsEligible(false);
        }
      } finally {
        if (isMounted) {
          setIsChecking(false);
        }
      }
    }

    if (!loadingUserData) {
      setIsChecking(true);
      checkEligibility();
    }

    return () => {
      isMounted = false;
    };
  }, [loadingUserData, user?._id]);

  if (loadingUserData || isChecking) {
    return null;
  }

  if (!isEligible) {
    return <Navigate to="/not-found" replace />;
  }

  return <>{children}</>;
}
